import React, { useEffect } from "react";
import "./Delivered.css";
import Order_Details_Card from "../order_details_card/Order_Details_Card";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllOrder,
  getDeliverdOrder,
} from "../../../../features/order/orderSlice";
import { logDOM } from "@testing-library/react";
import { encodeId } from "../../../../utils/common";
import No_data from "../../../common-components/No_data/No_data";

const Delivered = ({ type }) => {
  const data = [
    {
      order_id: 75843,
      item_no: 1,
      price: 1200,
      date: "13th May | 03:28 pm",
    },
    {
      order_id: 989,
      item_no: 3,
      price: 1500,
      date: "15th May | 03:00 pm",
    },
    {
      order_id: 75843,
      item_no: 1,
      price: 1200,
      date: "13th May | 03:28 pm",
    },
    {
      order_id: 989,
      item_no: 3,
      price: 1500,
      date: "15th May | 03:00 pm",
    },
    {
      order_id: 75843,
      item_no: 1,
      price: 1200,
      date: "13th May | 03:28 pm",
    },
    {
      order_id: 989,
      item_no: 3,
      price: 1500,
      date: "15th May | 03:00 pm",
    },
  ];

  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.deliverdOrders);

  useEffect(() => {
    const statusIds = [6];
    dispatch(getDeliverdOrder({ order_status_id: statusIds }));
  }, [dispatch]);

  // console.log(order,"order order");

  return (
    <section className="Delivered Ordered">
      {order?.data?.map((item) => {
        return (
          <Order_Details_Card
            track_order_text="Track Order"
            type={type}
            showTrackOrder={true}
            data={item}
            baseLike={`/delivered-order/${encodeId(item?.id)}`}
          />
        );
      })}

      {/* {order?.data?.length < 1 && (
          <div className="no_data_main_div">
            <No_data />
            <p className="no_data_text">No more orders to show</p>
          </div>
        )} */}
    </section>
  );
};

export default Delivered;
